import {CreateInforWorkOrderRequest} from '@domain/shifthandover'
import {ShiftEvent} from '@hconnect/common/types'
import {UseMutationResult} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import React, {useMemo} from 'react'

import {categoryToInforDepartmentCodeMapper} from '../mappers/inforDepartmentCode.mappers'
import {shiftEventToInforPriorityMapper} from '../mappers/inforPriority.mappers'

import {CreateInforMaintenanceNotificationFormDialog} from './CreateInforMaintenanceNotificationFormDialog'

type Props = {
  plantId: string
  event: ShiftEvent
  showDialog: boolean
  setDialog: (state: boolean) => void
  onNotificationCreated(): void
  onError?(): void
  createNotification: UseMutationResult<string, AxiosError, CreateInforWorkOrderRequest>
}

export const CreateInforMaintenanceNotification: React.FC<Props> = ({
  plantId,
  event,
  showDialog,
  setDialog,
  onError,
  onNotificationCreated,
  createNotification: createNotificationProp
}) => {
  const createNotification = (notification: CreateInforWorkOrderRequest) => {
    createNotificationProp.mutate(
      {
        ...notification
      },
      {
        onError: onError,
        onSuccess: onNotificationCreated
      }
    )
    setDialog(false)
  }

  const initialFormData = useMemo(
    () => ({
      eventId: event.id,
      equipmentTechnicalId:
        event.equipment?.idType === 'technicalId' ? event.equipment?.id : undefined,
      departmentCode: categoryToInforDepartmentCodeMapper(event.category),
      priority: shiftEventToInforPriorityMapper(event.priority)
    }),
    [event]
  )

  return (
    <CreateInforMaintenanceNotificationFormDialog
      plantId={plantId}
      open={showDialog}
      onClose={() => {
        setDialog(false)
      }}
      onConfirm={createNotification}
      event={event}
      initialFormData={initialFormData}
    />
  )
}
